import { pubSub } from './pubSub';
import { EmitContext } from './SocketEnums';

class SocketListener {
  route(context: EmitContext, message: any) {
    switch (context) {
      case EmitContext.CHAT:
        pubSub.publish(context, message);
        console.log('Chat message: ', message);
        break;
      case EmitContext.SCHEDULE:
        pubSub.publish(context, message);
        console.log('schedule: ', message);
        break;
      case EmitContext.EMOJI:
        pubSub.publish(context, message);
        console.log('emoji message: ', message);
        break;
      case EmitContext.BATCH:
        pubSub.publish(context, message);
        console.log('batch message: ', message);
        break;
      case EmitContext.DOUBT_SOLUTION:
        pubSub.publish(context, message);
        console.log('doubt solution message: ', message);
        break;
      default:
        console.log('Unknown message: ', message);
    }
  }
}

const socketListener = new SocketListener();

export { socketListener };
